















































import { androidStatusBarHeight } from "@/utils/statusBarHeight";
import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class PopGallery extends Vue {
  @Prop({ default: "" })
  private title?: string;
  @Prop({ default: false })
  private value?: boolean;
  @Prop({ default: 0 })
  private contentHeight?: any;
  @Prop({ default: 44 })
  private buttonWrappeHeight?: any;
  @Prop({ default: true })
  private setMaxHeight?: any;

  private closePop() {
    this.$emit("input", false);
  }

  get androidStatusBarHeight() {
    return androidStatusBarHeight;
  }
}
